import { apiClient } from './authService';

export const userService = {
  async getJobHistory({ page = 1, pageSize = 20, statusFilter = null, jobTypeFilter = null } = {}) {
    const params = {
      page,
      page_size: pageSize,
    };
    
    if (statusFilter) {
      params.status_filter = statusFilter;
    }
    
    if (jobTypeFilter) {
      params.job_type_filter = jobTypeFilter;
    }

    const response = await apiClient.get('/users/me/jobs', { params });
    return response.data;
  },

  async getCurrentUser() {
    const response = await apiClient.get('/users/me');
    return response.data;
  },

  async getCrystalProfiles() {
    const response = await apiClient.get('/users/me/crystal-profiles');
    return response.data;
  },
};

export default userService;
